import { TGIM_BACKEND_BASE_URL, TGIM_TENANT_KEY } from '../../config';

export class TgimBackendError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`tg-im-backend request failed with status ${status}`);
  }
}

export async function tgimFetch<T>(path: string, init?: RequestInit): Promise<T> {
  // A `FormData` body (avatar upload) needs the browser to set its own
  // `Content-Type: multipart/form-data; boundary=...` -- forcing `application/json` here would
  // send a malformed request the server's multipart parser can't read.
  const isFormData = init?.body instanceof FormData;

  const response = await fetch(`${TGIM_BACKEND_BASE_URL}${path}`, {
    ...init,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      'X-Tgim-Tenant-Key': TGIM_TENANT_KEY,
      ...init?.headers,
    },
  });

  const body = await response.json().catch(() => undefined);
  if (!response.ok) {
    throw new TgimBackendError(response.status, body);
  }
  return body as T;
}
